import {
  ComposerPrimitiveAttachments,
  ComposerPrimitiveAttachmentByIndex,
} from "@assistant-ui/core/react";

export type ComposerAttachmentsProps = ComposerPrimitiveAttachments.Props;

export type ComposerAttachmentByIndexProps =
  ComposerPrimitiveAttachmentByIndex.Props;

export const ComposerAttachmentByIndex = ComposerPrimitiveAttachmentByIndex;

export const ComposerAttachments = ComposerPrimitiveAttachments;
